import * as React from "react";
import { Text, View } from "@react-pdf/renderer";
const ReportHeader = ({
  translate,
  title,
  subtitle,
  subtitleText,
  otherParams,
  reportCode
}: {
  translate?: any;
  title?: string;
  subtitle?: string;
  subtitleText?: string;
  otherParams?: any;
  reportCode?: string;
}) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#CDCDCD",
        padding: "0pt 5pt 5pt",
        marginLeft: "5pt",
        marginBottom: "5pt"
      }}
    >
      <Text
        style={{
          fontSize: "14pt",
          padding: "0pt 5pt 0pt 5pt",
          fontWeight: "bold",
          fontFamily: "Segoe UI"
        }}
      >{`${translate("reports.report")}: ${title}`}</Text>
      {reportCode && (
        <Text
          style={{
            fontSize: "10pt",
            padding: "0pt 5pt 0pt 5pt",
            fontWeight: "bold",
            fontFamily: "Segoe UI"
          }}
        >{`${translate("report1.code")}: ${reportCode}`}</Text>
      )}
      {subtitle && (
        <Text
          style={{
            fontSize: "8pt",
            padding: "0pt 5pt 0pt",
            fontFamily: "Segoe UI"
          }}
        >{`${subtitleText}: ${subtitle}`}</Text>
      )}
      {otherParams && otherParams}
    </View>
  );
};

export default ReportHeader;
